import PropTypes from "prop-types";
import React, { Fragment, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { addToCart } from "../../redux/actions/cartActions";
import {
  addToWishlist,
  removeFromWishlist,
} from "../../redux/actions/wishlistActions";
import { addToCompare } from "../../redux/actions/compareActions";
import Rating from "./sub-components/ProductRating";
import styled from "styled-components";
import { useEffect } from "react";
import { getProductCartQty } from "../../helpers/product";
import { Accordion, AccordionSummary } from "@mui/material";
//import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
//import { Alert, AlertTitle } from "@material-ui/lab";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Typography from "@mui/material/Typography";
import AccordionDetails from "@mui/material/AccordionDetails";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFilePdf,
  faFileWord,
  faFileExcel,
  faFileImage,
  faFileAlt,
  faFileArchive,
  faFileAudio,
  faFileVideo,
} from "@fortawesome/free-solid-svg-icons";

const ProductDescriptionInfo = (props) => {
  const {
    product,
    discountedPrice,
    currency,
    finalDiscountedPrice,
    finalProductPrice,
    cartItems,
    wishlistItem,
    compareItem,
    addToast,
    addToCart,
    addToWishlist,
    removeFromWishlist,
    addToCompare,
    userData,
    isLoggedUser,
    visualizzaPrezzi,
    visualizzaGriglia,
    visualizzaQuantita,
    productCartQty,
    getDisponibili,
    getQtaInArrivo,
    toColor,
    description,
    refreshProduct,
    setSelectedColorSize,
  } = props;
  const isBetaRicambi = global.aziendaID === 4 ? true : false;

  //const [description, setDescription] = useState(descriptions?.length > 0 ? descriptions.find(d => d.ID === product.id) : "")
  const [numTaglie, setNumTaglie] = useState(0);
  const [selectedProductColor, setSelectedProductColor] = useState(
    product.variation ? product.variation[numTaglie]?.color : ""
  );

  const [selectedProductSize, setSelectedProductSize] = useState(
    product.variation && product.variation[numTaglie]?.size
      ? product.variation[numTaglie].size[0].name
      : ""
  );
  const [selectedProductPrice, setSelectedProductPrice] = useState(
    /*product.variation && product.variation[numTaglie]?.size
      ? product.variation[numTaglie].size[0].pricesco
      : */ ""
  );
  const [selectedIDArt, setSelectedIDArt] = useState(
    product.variation && product.variation[numTaglie]?.size
      ? product.variation[numTaglie].size[0].IDArtSizeColor
      : ""
  );
  const [productStock, setProductStock] = useState(
    product.variation && product.variation[numTaglie]?.size
      ? product.variation[numTaglie].size[0].stock
      : global.aziendaID == 2
      ? 9999
      : product.stock
  );
  const [quantityCount, setQuantityCount] = useState(1);

  const [selectedCodArt, setSelectedCodArt] = useState(
    product.variation && product.variation[numTaglie]?.size
      ? product.variation[numTaglie].size[0].skuSizeColor
      : product.sku
  );
  const [flgCatalogo, setFlgCatalogo] = useState(
    product.variation && product.variation[numTaglie]?.size
      ? product.variation[numTaglie].size[0].catalogo
      : 0
  );

  const colorInput = styled.div`
    .checkmark:after{
      background-color = 
    }
  `;
  const [firstLoading, setFirstLoading] = useState(true);
  const history = useHistory();
  var strings = require("../../translations/italian.json");
  useEffect(() => {
    console.log(quantityCount);
  }, [quantityCount]);
  useEffect(() => {
    setSelectedColorSize(selectedCodArt);
  }, [selectedCodArt]);
  useEffect(() => {
    for (var i = 0; i < product.variation?.length; i++)
      if (product.variation[i]?.size?.length > 0) {
        setNumTaglie(i);
        setSelectedProductColor(
          product.variation ? product.variation[i].color : ""
        );
        setSelectedProductSize(
          product.variation && product.variation[i].size
            ? product.variation[i].size[0].name
            : ""
        );
        setSelectedProductPrice(
          global.aziendaID == 3
            ? product.variation && product.variation[i].size
              ? product.variation[i].size[0].pricesco
              : ""
            : ""
        );
        break;
      }
    setFirstLoading(true);
    //setDescription(descriptions?.length > 0 ? descriptions.find(d => d.ID == product.id) : "")
  }, [product, refreshProduct]);
  /*useEffect(() => {
    console.log(descriptions)
    console.log(product.id)
    setDescription(descriptions?.length > 0 ? descriptions.find(d => d.ID == product.id) : "")
  }, [descriptions])*/
  const getLabelColor = () => {
    const colorProduct = product?.variation?.find(
      (_colorProduct) => _colorProduct.color === selectedProductColor
    );
    if (!colorProduct || !colorProduct.size) return null;
    const _colorcode = colorProduct.color.split("-")[0];
    const _colorname = colorProduct.color.split("-")[1];
    return (
      <>
        <label>
          <span
            title={selectedProductColor.split("-")[1]}
            style={{
              backgroundColor: colorProduct.hexColor
                ? toColor(colorProduct.hexColor)
                : "",
              backgroundImage: colorProduct.hexColor
                ? null
                : "url('https://dgaplanetshirt.com/assets/img/COLORI/" +
                  _colorcode +
                  ".png')",
              backgroundSize: "contain",
              position: "absolute",
              width: "20px",
              height: "20px",
              border:
                colorProduct.color === selectedProductColor
                  ? "2px solid #333"
                  : "2px solid #d9d9d9",
              borderRadius: "50%",
              content: "",
              transition: "0.3s",
            }}
          ></span>
          <span style={{ paddingLeft: "50px" }}>{_colorname}</span>
        </label>
      </>
    );
  };
  const getTableInfo = () => {
    //console.log({ isLoggedUser, visualizzaPrezzi, visualizzaGriglia, visualizzaQuantita })
    if (!visualizzaQuantita && !isLoggedUser) return null;

    const colorProduct = product?.variation?.find(
      (_colorProduct) => _colorProduct.color === selectedProductColor
    );
    if (!colorProduct || !colorProduct.size) return null;

    const taglieInfo = colorProduct.size;
    if (!taglieInfo || (taglieInfo || []) === 0) return null;

    const _colorcode = colorProduct.color.split("-")[0];
    const _colorname = colorProduct.color.split("-")[1];
    return (
      <>
        <div style={{ display: "none" }}>{getLabelColor()}</div>
        <table id="infoTable" style={{ width: "100%" }}>
          <thead style={{ width: "100%" }}>
            <tr>
              <th
                style={{
                  width: isLoggedUser ? "25%" : "30%",
                  backgroundColor: "#c3c3c3",
                  fontWeight: 500,
                  textAlign: "center",
                  padding: "5px",
                  BorderBottom: "0px",
                  BorderRight: "0px",
                  fontSize: "12px",
                  columnSpan: 2,
                  color: "black",
                  border: "1px solid black",
                }}
              >
                <span>Taglia</span>
              </th>
              <th
                style={{
                  width: isLoggedUser ? "25%" : "35%",
                  backgroundColor: "#c3c3c3",
                  fontWeight: 500,
                  textAlign: "center",
                  padding: "5px",
                  BorderBottom: "0px",
                  BorderRight: "0px",
                  fontSize: "12px",
                  columnSpan: 2,
                  color: "black",
                  border: "1px solid black",
                }}
              >
                <span>Disponibile</span>
              </th>
              <th
                style={{
                  width: isLoggedUser ? "25%" : "35%",
                  backgroundColor: "#c3c3c3",
                  fontWeight: 500,
                  textAlign: "center",
                  padding: "5px",
                  BorderBottom: "0px",
                  BorderRight: "0px",
                  fontSize: "12px",
                  columnSpan: 2,
                  color: "black",
                  border: "1px solid black",
                }}
              >
                <span>Arrivi</span>
              </th>
              {isLoggedUser && (
                <th
                  style={{
                    width: "25%",
                    backgroundColor: "#c3c3c3",
                    fontWeight: 700,
                    textAlign: "center",
                    padding: "5px",
                    BorderBottom: "0px",
                    BorderRight: "0px",
                    fontSize: "12px",
                    columnSpan: 2,
                    color: "black",
                    border: "1px solid black",
                  }}
                >
                  <span>Carrello</span>
                </th>
              )}
            </tr>
          </thead>
          <tbody style={{ width: "100%" }}>
            {taglieInfo.map((tagliaInfo) => {
              var nonPrenotabile =
                tagliaInfo.stock <= 0 &&
                tagliaInfo.stock - tagliaInfo.qtaOrdFor <= 0 &&
                tagliaInfo.qtaOrdFor - tagliaInfo.qtaImpCli <= 0 &&
                tagliaInfo.tag?.includes("PROMEMORIA");
              var nonEsiste = tagliaInfo.flgNoWeb == 1;

              return (
                <tr style={{ display: nonEsiste ? "none" : "table-row" }}>
                  <td
                    style={{
                      width: isLoggedUser ? "25%" : "30%",
                      textAlign: "center",
                      padding: "5px",
                      BorderBottom: "0px",
                      BorderRight: "0px",
                      fontSize: "12px",
                      columnSpan: 1,
                      color: "black",
                      border: "1px solid black",
                    }}
                  >
                    <span>{tagliaInfo.name || 0}</span>
                  </td>
                  <td
                    style={{
                      width: isLoggedUser ? "25%" : "35%",
                      textAlign: "center",
                      padding: "5px",
                      BorderBottom: "0px",
                      BorderRight: "0px",
                      fontSize: "12px",
                      columnSpan: 1,
                      color: "black",
                      border: "1px solid black",
                    }}
                  >
                    <span>
                      {getDisponibili(
                        tagliaInfo.stock,
                        tagliaInfo.qtaOrdFor,
                        tagliaInfo.color,
                        tagliaInfo.name,
                        tagliaInfo.catalogo,
                        tagliaInfo.qtaImpCli,
                        tagliaInfo.promo,
                        nonPrenotabile
                      )}
                    </span>
                  </td>
                  <td
                    style={{
                      width: isLoggedUser ? "25%" : "35%",
                      textAlign: "center",
                      padding: "5px",
                      BorderBottom: "0px",
                      BorderRight: "0px",
                      fontSize: "12px",
                      columnSpan: 1,
                      color: "black",
                      border: "1px solid black",
                    }}
                  >
                    <span>
                      {getQtaInArrivo(
                        tagliaInfo.qtaOrdFor,
                        tagliaInfo.qtaImpCli,
                        tagliaInfo.stock,
                        tagliaInfo.catalogo,
                        tagliaInfo.promo,
                        true
                      ) || ""}
                    </span>
                  </td>
                  {isLoggedUser && (
                    <td
                      style={{
                        width: "25%",
                        textAlign: "center",
                        padding: "5px",
                        BorderBottom: "0px",
                        BorderRight: "0px",
                        fontSize: "12px",
                        columnSpan: 1,
                        color: "black",
                        border: "1px solid black",
                        fontWeight: 700,
                      }}
                    >
                      <span>
                        {productCartQty(
                          selectedProductColor,
                          tagliaInfo.name,
                          true
                        )}
                      </span>
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      </>
    );
  };
  var qtaInCart = getProductCartQty(cartItems, product, null, null);
  /*const getDescription = (descriptions, id) =>
  {
    var des = descriptions?.find(d => d.ID === id)
    console.log(descriptions)
    return des? des.DesWeb : ""
  }*/
  return (
    <div className="product-details-content ml-70">
      <h1>{product.sku}</h1>
      <h2>
        {product.shortDescription ? product.shortDescription : product.name}
      </h2>

      {(isBetaRicambi
        ? visualizzaPrezzi
        : isLoggedUser || visualizzaPrezzi) && (
        <div
          className="product-details-price"
          style={{
            opacity: global.aziendaID != 1 ? "1" : firstLoading ? "0" : "1",
          }}
        >
          {isBetaRicambi ? (
            <Fragment>
              <span>
                {currency.currencySymbol +
                  (finalDiscountedPrice
                    ? finalDiscountedPrice
                    : product.price.toFixed(2))}
              </span>{" "}
            </Fragment>
          ) : null}
          {(discountedPrice !== null &&
            selectedProductPrice &&
            finalDiscountedPrice > discountedPrice) ||
          global.aziendaID == 1 ? (
            <Fragment>
              <span
                style={{
                  textDecoration: isBetaRicambi ? "line-through" : "",
                  fontSize: isBetaRicambi ? "18px" : "24px",
                }}
              >
                {currency.currencySymbol +
                  (selectedProductPrice
                    ? selectedProductPrice.toFixed(2)
                    : product.price.toFixed(2))}
                {global.aziendaID == 2 && (
                  <span style={{ fontSize: "15px" }}>/{product.altdat1}</span>
                )}
              </span>{" "}
              {/*} <span className="old">
              {(currency.currencySymbol + parseFloat(finalProductPrice).toFixed(2))}
        </span>*/}
              <span style={{ fontSize: "10px", marginLeft: "10px" }}>
                {userData.user.user?.ParIva ||
                userData.user.user?.ParIva !== "" ||
                userData?.user.user?.ParIva !== null
                  ? "  Iva esclusa"
                  : ""}
              </span>
            </Fragment>
          ) : (
            <span style={{ display: isBetaRicambi ? "none" : "block" }}>
              {currency.currencySymbol +
                parseFloat(
                  discountedPrice
                    ? discountedPrice
                    : selectedProductPrice
                    ? selectedProductPrice
                    : product.price
                ).toFixed(2)}{" "}
              <span style={{ fontSize: "10px" }}>
                {userData.user.user?.ParIva ||
                userData.user.user?.ParIva != "" ||
                userData.user.user?.ParIva != null
                  ? "Iva esclusa"
                  : ""}
              </span>
            </span>
          )}
        </div>
      )}

      <div className="pro-details-rating-wrap">
        {isLoggedUser ? (
          wishlistItem !== undefined ? (
            <div className="pro-details-wishlist">
              <button
                style={{
                  borderColor: "transparent",
                  backgroundColor: "transparent",
                }}
                className={"active"}
                disabled={false}
                title={"Rimuovi dai preferiti"}
                onClick={() => removeFromWishlist(product, addToast)}
              >
                <i
                  style={{ color: "lightblue" }}
                  class="fa fa-heart fa-2x"
                  title="Rimuovi dai preferiti"
                ></i>
              </button>
            </div>
          ) : (
            <div className="pro-details-wishlist">
              <button
                style={{
                  borderColor: "transparent",
                  backgroundColor: "transparent",
                }}
                className={"active"}
                disabled={false}
                title={"Aggiungi ai preferiti"}
                onClick={() => addToWishlist(product, addToast)}
              >
                <i
                  class="fa fa-heart-o fa-2x"
                  title="Aggiungi ai preferiti"
                ></i>
              </button>
            </div>
          )
        ) : null}

        {isLoggedUser && product.rating && product.rating > 0 ? (
          <div className="pro-details-rating" style={{ display: "none" }}>
            <Rating ratingValue={product.rating} />
          </div>
        ) : (
          ""
        )}
      </div>

      {global.aziendaID == 1 ? (
        <div
          className="shopping-cart-btn btn-hover text-center"
          style={{ padding: "10px" }}
        >
          <a
            style={{
              padding: "10px",
              border: "1px gray solid",
              display: "block",
              width: "100%",
            }}
            onClick={() =>
              window.open(
                process.env.PUBLIC_URL +
                  "/files/schede/" +
                  product.sku +
                  ".pdf",
                "_blank",
                "noopener,noreferrer"
              )
            }
          >
            Scheda tecnica
          </a>
        </div>
      ) : null}
      {product.variation ? (
        <div className="pro-details-size-color" style={{ display: "block" }}>
          {product.variation.length > 0 && (
            <div className="pro-details-color-wrap">
              <span>{global.aziendaID == 3 ? product.altdat2 : "Colore"}</span>
              <div className="pro-details-color-content">
                {product.variation.map((single, key) => {
                  return single.size == undefined ||
                    single.size?.length == 0 ? (
                    <></>
                  ) : (
                    <label
                      className={`pro-details-color-content--single`}
                      key={key}
                    >
                      <input
                        type="radio"
                        value={single.color}
                        name="product-color"
                        checked={
                          single.color === selectedProductColor ? "checked" : ""
                        }
                        onChange={() => {
                          setSelectedProductColor(single.color);
                          setSelectedProductSize(single.size[0].name);
                          setSelectedIDArt(single.size[0].IDArtSizeColor);
                          setSelectedCodArt(single.size[0].skuSizeColor);
                          setProductStock(single.size[0].stock);
                          setSelectedProductPrice(single.size[0].pricesco);
                          setFlgCatalogo(single.size[0].catalogo);
                          setFirstLoading(false);
                        }}
                      />
                      <span
                        title={single.color.split("-")[1]}
                        style={{
                          backgroundColor: single.hexColor
                            ? toColor(single.hexColor)
                            : "",
                          backgroundImage: single.hexColor
                            ? null
                            : "url('https://dgaplanetshirt.com/assets/img/COLORI/" +
                              single.color.split("-")[0] +
                              ".png')",
                          backgroundSize: "contain",
                          position: "absolute",
                          top: "-7px",
                          left: "-4px",
                          width: "20px",
                          height: "20px",
                          border:
                            single.color === selectedProductColor
                              ? "2px solid #333"
                              : "2px solid #d9d9d9",
                          borderRadius: "50%",
                          content: "",
                          transition: "0.3s",
                        }}
                      ></span>
                    </label>
                  );
                })}
              </div>
            </div>
          )}
          {product.variation.length > 0 && (
            <div className="pro-details-size">
              <span>{global.aziendaID == 3 ? product.altdat1 : "Taglia"}</span>
              <div className="pro-details-size-content">
                {product.variation &&
                  product.variation.map((single) => {
                    return single.color === selectedProductColor && single.size
                      ? single.size.map((singleSize, key) => {
                          var nonPrenotabile =
                            singleSize.stock <= 0 &&
                            singleSize.stock - singleSize.qtaOrdFor <= 0 &&
                            singleSize.qtaOrdFor - singleSize.qtaImpCli <= 0 &&
                            singleSize.tag?.includes("PROMEMORIA");
                          var nonEsiste = singleSize.flgNoWeb == 1;
                          return (
                            <label
                              className={`pro-details-size-content--single`}
                              key={key}
                              style={{
                                paddingLeft: "10px",
                                paddingRight: "10px",
                                color:
                                  nonPrenotabile == 1 ? "lightgray" : "black",
                                display:
                                  nonEsiste == 1 ? "none" : "inline-block",
                              }}
                            >
                              <input
                                style={{
                                  paddingLeft: "10px",
                                  paddingRight: "10px",
                                }}
                                type="radio"
                                value={singleSize.name}
                                checked={
                                  singleSize.name === selectedProductSize
                                    ? "checked"
                                    : ""
                                }
                                disabled={nonPrenotabile == 1}
                                onChange={() => {
                                  setSelectedProductSize(singleSize.name);
                                  setSelectedIDArt(singleSize.IDArtSizeColor);
                                  setSelectedCodArt(singleSize.skuSizeColor);
                                  setProductStock(singleSize.stock);
                                  setSelectedProductPrice(singleSize.pricesco);
                                  setQuantityCount(1);
                                  setFlgCatalogo(singleSize.catalogo);
                                  setFirstLoading(false);
                                }}
                              />
                              <span className="size-name">
                                {singleSize.name}
                              </span>
                            </label>
                          );
                        })
                      : "";
                  })}
              </div>
            </div>
          )}
        </div>
      ) : (
        ""
      )}
      {product.affiliateLink ? (
        <div className="pro-details-quality">
          <div className="pro-details-cart btn-hover ml-0">
            <a
              href={product.affiliateLink}
              rel="noopener noreferrer"
              target="_blank"
            >
              Buy Now
            </a>
          </div>
        </div>
      ) : (
        <div style={{ marginBottom: "20px" }}></div>

        /*<div className="pro-details-quality">
 
           <div className="cart-plus-minus">
             
             <button
               onClick={() =>{
                 setQuantityCount(quantityCount > 1 ? quantityCount - 1 : 1)
                 document.getElementById("cart-box").value=  quantityCount > 1 ? quantityCount - 1 : 1
               }
               }
               className="dec qtybutton"
             >
               -
             </button>
 
             <input
               className="cart-plus-minus-box"
               id="cart-box"
               type="text"
               defaultValue={1}
               onBlur={e => {
                 if (e.target.value > productStock - productCartQty && flgCatalogo == 0)
                 {
                   var newQta = productStock-productCartQty;
                   setQuantityCount(newQta)
                 }
                 else
                 {setQuantityCount(e.target.value)}
               }}
             />
 
             <button
               onClick={() =>{
                 setQuantityCount(
                   quantityCount < productStock - productCartQty || flgCatalogo == 1
                     ? quantityCount + 1
                     : quantityCount
                 );
                 document.getElementById("cart-box").value=  quantityCount < productStock - productCartQty
                 ? quantityCount + 1
                 : quantityCount
               }
                             
               }
               className="inc qtybutton"
             >
               +
             </button>
 
           </div>
           <div className="pro-details-cart btn-hover">
             {productStock && productStock > 0  || flgCatalogo == 1 ? (
               <button
                 onClick={() =>{
                   //var productNoVar = JSON.parse(JSON.stringify(product));
                   //delete productNoVar['variation']
                   product.catalogo = flgCatalogo
                   addToCart(
                     product,
                     addToast,
                     quantityCount,
                     selectedProductColor,
                     selectedProductSize,
                     selectedIDArt
                   )
                 }
                   
                 }
                 disabled={ flgCatalogo == 0 && productCartQty >= productStock}
               >
                 {" "}
                 {flgCatalogo == 1 ? "Prenota" : strings.add_to_cart}{" "}
               </button>
             ) : (
               <button disabled>Non Disponibile</button>
             )}
           </div>
           <div className="pro-details-wishlist">
             <button
               className={wishlistItem !== undefined ? "active" : ""}
               disabled={wishlistItem !== undefined}
               title={
                 wishlistItem !== undefined
                   ? "Aggiunto ai preferiti"
                   : "Aggiungi ai preferiti"
               }
               onClick={() => addToWishlist(product, addToast)}
             >
               <i className="pe-7s-like" />
             </button>
           </div>
           <div className="pro-details-compare">
             <button
               className={compareItem !== undefined ? "active" : ""}
               disabled={compareItem !== undefined}
               title={
                 compareItem !== undefined
                   ? "Added to compare"
                   : "Add to compare"
               }
               onClick={() => addToCompare(product, addToast)}
             >
               <i className="pe-7s-shuffle" />
             </button>
           </div>
         </div>*/
      )}
      {/*<div className="pro-details-meta">
          <span>Riferimento :</span>
          <ul>
            {selectedCodArt}
          </ul>
            </div>*/}
      {product.category && !isBetaRicambi ? (
        <div className="pro-details-meta">
          <span>Categorie :</span>
          <ul>{product.category}</ul>
        </div>
      ) : (
        ""
      )}
      {isBetaRicambi ? (
        <div
          className="pro-details-meta"
          style={{ flexDirection: "column", alignItems: "flex-start" }}
        >
          <div style={{ display: product.category ? "flex" : "none" }}>
            <span>Categoria :</span>
            <ul>{product.category}</ul>
          </div>
          <div style={{ display: product.subcategory ? "flex" : "none" }}>
            <span>Sottocategoria :</span>
            <ul>{product.subcategory}</ul>
          </div>
          <div style={{ display: product.brands ? "flex" : "none" }}>
            <span>Modello :</span>
            <ul>{product.brands}</ul>
          </div>
          <div style={{ display: product.templates ? "flex" : "none" }}>
            <span>Marca :</span>
            <ul>{product.templates}</ul>
          </div>
        </div>
      ) : (
        ""
      )}
      {isBetaRicambi ? (
        <div
          className="shopping-cart-btn btn-hover text-center"
          style={{ padding: "10px" }}
        >
          <Link
            style={{
              padding: "10px",
              border: "1px gray solid",
              display: "block",
              width: "100%",
            }}
            to={
              process.env.PUBLIC_URL +
              "/shop-grid-full-width/" +
              (product.category ? "category=" + product.category : "") +
              (product.category && product.subcategory
                ? "&subcategory=" + product.subcategory
                : "") +
              (product.category && product.subcategory && product.brands
                ? "&brands=" + product.brands
                : "") +
              (product.category &&
              product.subcategory &&
              product.brands &&
              product.templates
                ? "&templates=" + product.templates
                : "")
            }
          >
            Cerca articoli simili
          </Link>
        </div>
      ) : null}
      {product.tag.length > 0 && global.aziendaID != 3 ? (
        <div className="pro-details-meta">
          <span style={{ width: "15%" }}>Tags :</span>
          <ul>
            {product.tag.map((single, key) => {
              return (
                <li key={key}>
                  <ul>{single}</ul>
                </li>
              );
            })}
          </ul>
        </div>
      ) : (
        ""
      )}
      {global.aziendaID == 1 && (
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Typography component="span">
              Disponibilità taglia/colore {getLabelColor()}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>{getTableInfo()}</AccordionDetails>
        </Accordion>
      )}
      <div className="pro-details-list">
        {/*<p>{product.shortDescription}</p>*/}
        <div
          style={{ width: "150%" }}
          dangerouslySetInnerHTML={{
            __html: description?.DesWeb?.replace(
              "border-collapse: collapse; width: 100%;",
              "border-collapse: collapse; border: none; width: 100%;"
            ),
          }}
        ></div>
      </div>
      <div
        style={{
          display: "flex", // Abilita Flexbox per i contenitori dei pulsanti
          flexWrap: "wrap", // Permette ai pulsanti di andare a capo su più righe
          gap: "15px", // Spazio tra i pulsanti (sia orizzontale che verticale)
          justifyContent: "center", // Centra i pulsanti se non riempiono tutta la riga
        }}
      >
        {product.files?.map((file, index) => {
          // Funzione per ottenere l'icona in base all'estensione del file
          const getFileIcon = (fileName) => {
            // Assumiamo che file.name contenga il nome del file completo
            const name =
              typeof fileName === "object" && fileName !== null && fileName.name
                ? fileName.name
                : fileName;
            const extension = name.split(".").pop().toLowerCase();
            switch (extension) {
              case "pdf":
                return faFilePdf;
              case "doc":
              case "docx":
                return faFileWord;
              case "xls":
              case "xlsx":
                return faFileExcel;
              case "jpg":
              case "jpeg":
              case "png":
              case "gif":
                return faFileImage;
              case "zip":
              case "rar":
              case "7z":
                return faFileArchive;
              case "mp3":
              case "wav":
                return faFileAudio;
              case "mp4":
              case "avi":
              case "mov":
                return faFileVideo;
              default:
                return faFileAlt; // Icona generica per altri tipi di file
            }
          };

          // Determina l'icona e il testo da visualizzare
          const icon = getFileIcon(file);
          const fileNameToDisplay =
            typeof file === "object" && file !== null && file.name
              ? file.name
              : file;

          return (
            <div
              key={index}
              style={{
                // Larghezza del 30% per permettere 3 pulsanti per riga con gap
                flex: "0 0 calc(33.33% - 10px)", // 10px è 2/3 del gap totale (15px) diviso per lato
                maxWidth: "calc(33.33% - 10px)", // Assicura che non superi la larghezza
                minWidth: "150px", // Larghezza minima per evitare che siano troppo piccoli su schermi ridotti
                textAlign: "center", // Centra il contenuto del div (il pulsante)
              }}
            >
              <a
                href={global.endPointBaseFiles + fileNameToDisplay}
                rel="noopener noreferrer"
                target="_blank"
                style={{
                  display: "flex",
                  flexDirection: "column", // Stack icona e testo verticalmente
                  alignItems: "center", // Centra orizzontalmente icona e testo
                  justifyContent: "center",
                  padding: "15px 10px", // Padding del pulsante
                  border: "1px solid #ddd", // Bordo sottile e leggero
                  borderRadius: "8px",
                  backgroundColor: "#ffffff", // Sfondo bianco
                  color: "#333", // Testo grigio scuro
                  textDecoration: "none",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.08)", // Ombra più sottile
                  transition: "all 0.3s ease",
                  height: "100%", // Assicura che i pulsanti abbiano la stessa altezza se il testo varia
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#f0f0f0"; // Leggero grigio al hover
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow =
                    "0 4px 8px rgba(0, 0, 0, 0.15)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "#ffffff"; // Torna al bianco
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 2px 4px rgba(0, 0, 0, 0.08)";
                }}
              >
                <FontAwesomeIcon
                  icon={icon}
                  style={{
                    marginBottom: "8px",
                    fontSize: "32px",
                    color: "#007bff",
                  }}
                />{" "}
                {/* Icona più grande e colorata */}
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: "bold",
                    textAlign: "center",
                    wordBreak: "break-word",
                  }}
                >
                  {fileNameToDisplay}
                </span>
              </a>
            </div>
          );
        })}
      </div>
      {product.variation?.length == 0 && isLoggedUser ? (
        <div className="pro-details-quality">
          {product.variation.length == 0 && (
            <span>{qtaInCart} pz già nel carrello</span>
          )}
          <div
            className="cart-plus-minus"
            style={isBetaRicambi ? { width: "20%" } : {}}
          >
            <button
              onClick={() =>
                setQuantityCount(quantityCount > 1 ? quantityCount - 1 : 1)
              }
              className="dec qtybutton"
            >
              -
            </button>
            <input
              className="cart-plus-minus-box"
              type="text"
              value={quantityCount}
              onChange={(e) =>
                setQuantityCount(parseInt(e.target.value ? e.target.value : 1))
              }
            />
            <button
              onClick={() =>
                setQuantityCount(
                  isBetaRicambi
                    ? quantityCount + 1
                    : quantityCount < productStock - qtaInCart
                    ? quantityCount + 1
                    : quantityCount
                )
              }
              className="inc qtybutton"
            >
              +
            </button>
          </div>

          <div
            className="pro-details-cart btn-hover"
            style={isBetaRicambi ? { width: "60%" } : {}}
          >
            {(productStock && productStock > 0) || isBetaRicambi ? (
              <button
                onClick={() => {
                  //console.log(selectedIDArt);
                  addToCart(
                    product,
                    addToast,
                    quantityCount,
                    selectedProductColor,
                    selectedProductSize,
                    selectedIDArt
                  );
                  setQuantityCount(1);
                }}
                disabled={productCartQty >= productStock}
              >
                {" "}
                {quantityCount + qtaInCart > productStock
                  ? strings.add_to_cart_verify
                  : strings.add_to_cart}{" "}
              </button>
            ) : (
              <button disabled>{strings.out_of_stock}</button>
            )}
          </div>

          {isLoggedUser ? (
            wishlistItem !== undefined ? (
              <div className="pro-details-wishlist">
                <button
                  style={{
                    borderColor: "transparent",
                    backgroundColor: "transparent",
                  }}
                  className={"active"}
                  disabled={false}
                  title={"Rimuovi dai preferiti"}
                  onClick={() => removeFromWishlist(product, addToast)}
                >
                  <i
                    style={{ color: "lightblue" }}
                    class="fa fa-heart fa-2x"
                    title="Rimuovi dai preferiti"
                  ></i>
                </button>
              </div>
            ) : (
              <div className="pro-details-wishlist">
                <button
                  style={{
                    borderColor: "transparent",
                    backgroundColor: "transparent",
                  }}
                  className={"active"}
                  disabled={false}
                  title={"Aggiungi ai preferiti"}
                  onClick={() => addToWishlist(product, addToast)}
                >
                  <i
                    class="fa fa-heart-o fa-2x"
                    title="Aggiungi ai preferiti"
                  ></i>
                </button>
              </div>
            )
          ) : null}

          <div className="pro-details-compare" style={{ display: "none" }}>
            <button
              className={compareItem !== undefined ? "active" : ""}
              disabled={compareItem !== undefined}
              title={
                compareItem !== undefined
                  ? "Added to compare"
                  : "Add to compare"
              }
              onClick={() => addToCompare(product, addToast)}
            >
              <i className="pe-7s-shuffle" />
            </button>
          </div>
        </div>
      ) : null}
      {/*<div className="pro-details-social">
        <ul>
          <li>
            <a href="//facebook.com">
              <i className="fa fa-facebook" />
            </a>
          </li>
          <li>
            <a href="//dribbble.com">
              <i className="fa fa-dribbble" />
            </a>
          </li>
          <li>
            <a href="//pinterest.com">
              <i className="fa fa-pinterest-p" />
            </a>
          </li>
          <li>
            <a href="//twitter.com">
              <i className="fa fa-twitter" />
            </a>
          </li>
          <li>
            <a href="//linkedin.com">
              <i className="fa fa-linkedin" />
            </a>
          </li>
        </ul>
      </div>*/}
    </div>
  );
};

ProductDescriptionInfo.propTypes = {
  addToCart: PropTypes.func,
  addToCompare: PropTypes.func,
  addToWishlist: PropTypes.func,
  removeFromWishlist: PropTypes.func,
  addToast: PropTypes.func,
  cartItems: PropTypes.array,
  compareItem: PropTypes.array,
  currency: PropTypes.object,
  discountedPrice: PropTypes.number,
  finalDiscountedPrice: PropTypes.number,
  finalProductPrice: PropTypes.number,
  product: PropTypes.object,
  wishlistItem: PropTypes.object.isRequired,
  userData: PropTypes.object,
};

const mapDispatchToProps = (dispatch) => {
  return {
    addToCart: (
      item,
      addToast,
      quantityCount,
      selectedProductColor,
      selectedProductSize,
      selectedIDArt
    ) => {
      dispatch(
        addToCart(
          item,
          addToast,
          quantityCount,
          selectedProductColor,
          selectedProductSize,
          selectedIDArt
        )
      );
    },
    removeFromWishlist: (item, addToast) => {
      dispatch(removeFromWishlist(item, addToast));
    },
    addToWishlist: (item, addToast) => {
      dispatch(addToWishlist(item, addToast));
    },
    addToCompare: (item, addToast) => {
      dispatch(addToCompare(item, addToast));
    },
  };
};

const mapStateToProps = (state) => {
  return {
    userData: state.userData,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductDescriptionInfo);
